export class RouteDto {
  from: string;
  to: string;
  departLocal: Date;
}
